"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generate_react_typescript_config_1 = __importDefault(require("./generate-react-typescript-config"));
const getGenerateReactNearOperationTsConfig = ({ baseTypesPath = "types/generated/graphql-types.ts", generatedTypesExtension = ".generated.ts", } = {}) => {
    return {
        types: {
            ...generate_react_typescript_config_1.default,
            plugins: ["typescript", "fragment-matcher"],
        },
        operationRoot: {
            documents: ["./src/**/*.graphql", "!./src/types/**/*"],
            preset: "near-operation-file",
            presetConfig: { extension: generatedTypesExtension, baseTypesPath },
            config: {
                skipTypename: true,
                operationResultSuffix: "OperationResult",
                avoidOptionals: false,
                maybeValue: "T | null",
            },
            plugins: ["typescript-operations", "typed-document-node"],
        },
    };
};
exports.default = getGenerateReactNearOperationTsConfig;
//# sourceMappingURL=generate-react-near-operation-typescript-config.js.map